import MerchantConfirmModal from '@modules/merchant/layout/MerchantConfirmModal';
import { memo } from 'react';

const LogoutConfirmModal = memo(({ open, onClose, onConfirm }) => (
  <MerchantConfirmModal
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    title="Confirm Logout"
    description="Are you sure you want to log out? You will need to log in again to access your account."
    confirmLabel="Log Out"
    pendingLabel="Logging out..."
    cancelLabel="Cancel"
  />
));

LogoutConfirmModal.displayName = 'LogoutConfirmModal';

export default LogoutConfirmModal;
